import React, { useMemo } from "react";

import AddIcon from "@material-ui/icons/Add";
import { Button } from "react-admin";
import { Link } from "react-router-dom";
import { stringify } from "query-string";

const AddButton = ({ record, config }) => {
  const disabled = useMemo(
    () =>
      parseInt(record?.duration || 0, 10) +
        parseInt(config?.duration || 0, 10) ===
      18,
    [record?.duration, config?.duration]
  );

  if (disabled || !record || !config) {
    return null;
  }
  return (
    <Button
      label={"ra.action.add_wp"}
      component={Link}
      color="secondary"
      variant="contained"
      to={{
        pathname: `/executive-project-wps/create`,
        search: stringify({
          source: JSON.stringify({
            executive_project_id: record?.executive_project_id,
          }),
        }),
      }}
    >
      <AddIcon />
    </Button>
  );
};

export default AddButton;
